[
  {
    "id": 0,
    "name": "new",
    "color": "#ffcccc",
    "orders": [],
    "page": 1,
    "pageSize": 10,
    "totalItems": 0,
    "totalPages": 1,
    "loading": false
  },
  {
    "id": 1,
    "name": "cooking",
    "color": "#ffebcc",
    "orders": [],
    "page": 1,
    "pageSize": 10,
    "totalItems": 0,
    "totalPages": 1,
    "loading": false
  },
  {
    "id": 2,
    "name": "ready-to-deliver",
    "color": "#ffffcc",
    "orders": [],
    "page": 1,
    "pageSize": 10,
    "totalItems": 0,
    "totalPages": 1,
    "loading": false
  },
  {
    "id": 3,
    "name": "assigned-to",
    "color": "#e9ffcc",
    "orders": [],
    "page": 1,
    "pageSize": 10,
    "totalItems": 0,
    "totalPages": 1,
    "loading": false
  },
  {
    "id": 4,
    "name": "delivered",
    "color": "#ccffcc",
    "orders": [],
    "page": 1,
    "pageSize": 10,
    "totalItems": 0,
    "totalPages": 1,
    "loading": false
  }
]
